import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RefreshService {
  private refreshSubject = new Subject<void>();
  refresh$ = this.refreshSubject.asObservable();

  triggerRefresh(context: string = 'general'): void {
    console.log(`REFRESH SERVICE: Notificando cambio (contexto: ${context})`);
    this.refreshSubject.next();
  }
}
